import { RG_TYPE } from "@project-rouge/rg-core";
import { V3toVector3, getRgObjectsOfType as getRgObjectsOfType$1 } from "@project-rouge/rg-three";
import { Box3, MathUtils, OrthographicCamera, Vector3 } from "three";
var addToTop = 3;
function frameToSite({ obj, camera, canvas, direction = new Vector3(1, -1, 1) }) {
	const points = getRgObjectsOfType$1(obj, RG_TYPE.Zone).flatMap((zone) => zone.data.polygons).flat().flatMap(V3toVector3);
	const height = addToTop + Math.max(...getRgObjectsOfType$1(obj, RG_TYPE.Building).flatMap((building) => building.data.levels).flatMap((lvl) => lvl.floorWorldBottom));
	const box = new Box3().setFromPoints(points);
	box.expandByVector(new Vector3(0, height, 0));
	const boxSize = box.getSize(new Vector3());
	const center = box.getCenter(new Vector3());
	if (camera instanceof OrthographicCamera) {
		camera.position.copy(center).sub(direction.clone().normalize().multiplyScalar(500));
		camera.lookAt(center);
		const screenBoxSize = toScreenBox(camera, box).getSize(new Vector3());
		if (screenBoxSize.x > screenBoxSize.y) camera.zoom = canvas.width / screenBoxSize.x;
		else camera.zoom = canvas.height / screenBoxSize.y;
		camera.updateProjectionMatrix();
		camera.updateMatrix();
	} else {
		const halfSizeToFitOnScreen = boxSize.length() * .5;
		const halfFovY = MathUtils.DEG2RAD * camera.fov * .5;
		const distance = halfSizeToFitOnScreen / Math.tan(halfFovY);
		camera.position.copy(direction).multiplyScalar(-distance).add(center);
		camera.lookAt(center);
	}
}
function toScreenBox(camera, box) {
	camera.updateWorldMatrix(true, true);
	const vertices = [
		new Vector3(box.min.x, box.min.y, box.min.z),
		new Vector3(box.min.x, box.max.y, box.min.z),
		new Vector3(box.min.x, box.min.y, box.max.z),
		new Vector3(box.min.x, box.max.y, box.max.z),
		new Vector3(box.max.x, box.max.y, box.max.z),
		new Vector3(box.max.x, box.max.y, box.min.z),
		new Vector3(box.max.x, box.min.y, box.max.z),
		new Vector3(box.max.x, box.min.y, box.min.z)
	].map((v) => v.applyMatrix4(camera.matrixWorldInverse));
	return new Box3().setFromPoints(vertices);
}
export { frameToSite };

//# sourceMappingURL=index232.js.map